import { useInfiniteQuery } from '@zg-rentals/react-query5';
import getPropertySearchQueryOptions from './propertySearchQueryOptions';

/**
 * Lightweight check for whether the current user owns at least one property.
 * Shares the same infinite query as usePropertyFilter so React Query deduplicates the request.
 */
export default function useHasProperties() {
  const { data, isLoading } = useInfiniteQuery({
    ...getPropertySearchQueryOptions(),
    staleTime: 5 * 60 * 1000,
  });

  return {
    hasProperties: (data?.pages[0]?.listings?.length ?? 0) > 0,
    isLoading,
  };
}
